import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

/**
 * Renders a scannable QR code for the join URL so players can reach the site
 * without typing the (ugly) CloudFront domain. The 4-char game code is still
 * shown separately for players to enter after landing.
 */
export function JoinQR({ code }: { code: string }) {
  const [dataUrl, setDataUrl] = useState<string>('');
  // Encode the code in the path so scanning lands the player straight on the
  // game's join page — they only need to type a nickname.
  const joinUrl = `${window.location.origin}/play/${encodeURIComponent(code)}`;

  useEffect(() => {
    void QRCode.toDataURL(joinUrl, { margin: 1, width: 220, color: { dark: '#14110d', light: '#f4a300' } })
      .then(setDataUrl)
      .catch(() => setDataUrl(''));
  }, [joinUrl]);

  return (
    <div className="joinqr">
      {dataUrl && <img src={dataUrl} alt="Scan to join" width={220} height={220} />}
      <div className="joininfo">
        <div className="muted small">Scan to join, then enter code</div>
        <div className="bigcode">{code}</div>
      </div>
    </div>
  );
}
